module.exports = __webpack_public_path__ + "img/20200110155354862.8eb6c1b8.jpg";